import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {FIELDS} from "../../fields3/fields.const"
import FieldString from "../../fields3/generic/string/string";
import FieldProject from "../../fields3/generic/entity/project/project";
import FieldDocumentAccessRead from "../../fields3/system/document/access/access-read";
import FieldDocumentAccessWrite from "../../fields3/system/document/access/access-write";

const DEFAULT_WIDTH = 140

const baseConfig = [
    {fieldId: 'name',               label: 'Name',              type: FIELDS.STRING},
    {fieldId: 'momentCreated',      label: 'Date created',      type: FIELDS.DATE,                      defaultWidth: DEFAULT_WIDTH},

    {fieldId: 'lastUpdated',        label: 'Last updated',      type: FIELDS.DATE,                      defaultWidth: DEFAULT_WIDTH},
    {fieldId: 'lastViewed',         label: 'Last opened',       type: FIELDS.DATE,                      defaultWidth: DEFAULT_WIDTH},

    {fieldId: 'createdByUserId',    label: 'Created by',        type: FIELDS.USER,                      defaultWidth: DEFAULT_WIDTH},
    {fieldId: 'editors',            label: 'Editors',           type: FIELDS.USERS,                     defaultWidth: DEFAULT_WIDTH},


    {fieldId: 'projectId',          label: 'Project',           type: FIELDS.PROJECT,                   defaultWidth: DEFAULT_WIDTH},
    // {fieldId: 'projectFullPath',    label: 'Project full path', type: FIELDS.PROJECT_FULL_PATH,         defaultWidth: DEFAULT_WIDTH},
    {fieldId: 'projectFullPath',    label: 'Project full path', type: FIELDS.PROJECT,                   defaultWidth: DEFAULT_WIDTH},
    {fieldId: 'historyCount',       label: 'History',           type: FIELDS.NUMBER,                    defaultWidth: DEFAULT_WIDTH},
    {fieldId: 'pagesCount',         label: 'Pages',             type: FIELDS.NUMBER,                    defaultWidth: DEFAULT_WIDTH},

    {fieldId: 'noteTypeId',         label: 'Document type',     type: FIELDS.DOCUMENT_TYPE,             defaultWidth: DEFAULT_WIDTH},

    {fieldId: 'accessRead',         label: 'Access read',       type: FIELDS.DOCUMENT_ACCESS_READ,      defaultWidth: DEFAULT_WIDTH},
    {fieldId: 'accessWrite',        label: 'Access write',      type: FIELDS.DOCUMENT_ACCESS_WRITE,     defaultWidth: DEFAULT_WIDTH},
]

export default class DocFields extends FieldsCollection {

    constructor() {

        const fieldsConfig = baseConfig;
        // we can modify base config with params in constructor if needed

        super(fieldsConfig);
    }

    get name()                 : FieldString { return this.get('name') as FieldString }
    get projectId()            : FieldProject { return this.get('projectId') as FieldProject }
    get accessRead()           : FieldDocumentAccessRead { return this.get('accessRead') as FieldDocumentAccessRead }
    get accessWrite()          : FieldDocumentAccessWrite { return this.get('accessWrite') as FieldDocumentAccessWrite }

}
